import React, { Component } from 'react';
import { API_URLS } from '../helpers/api/API_URLS';

import { SearchForm } from '../helpers/uiComponents/Search';
import { Reload } from '../helpers/uiComponents/Reload';
import { InputRow } from '../helpers/uiComponents/InputRow';

class AllEndpoints extends Component {
	constructor(props) {
		super(props);
		this.state = {
			endpoints: [],
			sfnpoints: [],
			isLoading: false,
			prodClients: [],
			sfnClients: [],
		}
		this.componentDidMount = this.componentDidMount.bind(this);
		this.loadEndpoints = this.loadEndpoints.bind(this);
	}

	componentDidMount() {
		this.loadEndpoints();
		setInterval(this.loadEndpoints.bind(this), 300000);
	}

	loadEndpoints() {
		var postParams = {
			method: "GET",
		}

// FETCH FROM PRODUCTS API
		fetch(API_URLS.ENDPOINTS, postParams)
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong ...'); }
		})
		.then(data => {
			if (data.success === false) {
				// console.log(data);
				this.setState({ endpoints: [] });
				document.getElementById("products-list").insertAdjacentHTML(
					'beforeend',
					'No Endpoints found. Please check connection to products.mm-api.agency/admin/sites.');
			} else {
				if (data) {
					this.setState({ endpoints: data});
					// console.log(this.state.endpoints);

					var clientArr = [];
					for (var i = data.length - 1; i >= 0; i--) {
						clientArr.push(
							{
								"name" : data[i].name,
								"value" : data[i].clientCode,
							},
						);
					}
					clientArr.reverse();
					this.setState({
						prodClients: clientArr,
					});
				}
			}
		})
		.catch(error => console.log(error));

// FETCH FROM SFN API
		fetch(API_URLS.SFNENDPOINTS, postParams)
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong ...'); }
		})
		.then(data => {
			if (data.success === false) {
				// console.log(data);
				this.setState({ sfnpoints: [] });
				document.getElementById("sfn-list").insertAdjacentHTML(
					'beforeend',
					'No Endpoints found. Please check connection to sfn.mm-api.agency/admin/sites.');
			} else {
				if (data) {
					this.setState({ sfnpoints: data });
					// console.log(this.state.sfnpoints);

					var clientArr = [];
					for (var i = data.length - 1; i >= 0; i--) {
						clientArr.push(
							{
								"name" : data[i].name,
								"value" : data[i].clientCode,
							},
						);
					}
					clientArr.reverse();
					this.setState({
						sfnClients: clientArr,
					});
				}
			}
		})
		.catch(error => console.log(error));
	}
	upload(fieldId, parse) {
		var formData = new FormData();
		var newFile = document.getElementById(fieldId).files[0];
		formData.append('file', newFile);

		console.log(newFile);

		let clientCode;
		if (parse === "products") {
			clientCode = document.getElementById("productsClientCode");
			clientCode = clientCode.options[clientCode.selectedIndex].value;
		} else if (parse === "sfn") {
			clientCode = document.getElementById("sfnClientCode");
			clientCode = clientCode.options[clientCode.selectedIndex].value;
		}
		if (clientCode === "Select...") {
			clientCode = "all"
		}

		var fileParams = {
			headers: {
				"authorization": "Bearer " + localStorage.getItem("token"),
			},
			body: formData,
			method: "POST",
		}

		if (newFile === undefined) {
			alert("You must select a .CSV or .XLSX file to upload");
			return false;
		}

		if (window.confirm("If this is an update to an existing catalog, uploading will result in changes automatically distributing to websites that use this catalog.\n\n If this catalog is new, it will be available in Clients : Product Catalogs tool for use on websites.\n\n You will receive an email when your upload is complete. \n\nAre you sure you want to continue?")) {
			console.log("your catalog is uploading...");
			fetch("https://"+parse+".mm-api.agency/parse/"+clientCode, fileParams)
			.then(response => {
				if (response.ok) { return response.json(); } 
				else { throw new Error('Something went wrong ...'); }
			})
			.then(data => {
				console.log(data);
			})
			.catch(error => {
				console.log(error);
			});
		} else {
			console.log("cancelled...")
		}
	}

	render() {
		const { isLoading, endpoints, sfnpoints, sfnClients, prodClients } = this.state;

		let allproducts = "https://products.mm-api.agency/all/all";
		let allsfn = "https://sfn.mm-api.agency/all/all";

		if (isLoading) {
			return <p style={{textAlign: 'center', marginTop: '100px'}}><i className="loading fas fa-spinner"></i></p>;
		}

		return (
			<div>
				<Reload click={() => this.componentDidMount()} />

				<section className="section search-eps">
					<h3>Search Endpoints</h3>
					<SearchForm page="endpoints" />
				</section>
				<div id="endpoint-lists">
					<div>
						<div className="endpoints-header">
							<h2>Manage Data & Catalogs</h2>
							<h4>Edit Product Data</h4>
							<p style={{textAlign: 'center'}}><strong><a className="button" style={{display: 'inline-block'}} href="http://prodmin.mm-api.agency" target="_blank" rel="noopener noreferrer">Prodmin</a></strong></p>
							<div className="upload-wrapper">
								<h4>Upload Product Catalog</h4>
								<input type="file" name="productsUpload" id="productsUpload" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/>
								<InputRow label="Is This Catalog Client Specific? Leave empty if 'No'" type="select" options={prodClients} property="clientCode" id="productsClientCode" />
								<button className="button" onClick={() => this.upload("productsUpload", "products")} >
									Upload Catalog <i className="fas fa-upload icon"></i>
								</button>
							</div>
						</div>

						<ul id="products-list" className="endpoint-list result-list">
							<h2>Product Data Endpoints</h2>
							<li><a href={allproducts} target="_blank" rel="noopener noreferrer">All Data</a></li>
							{endpoints.map(point => <li key={point.id}><a href={"https://products.mm-api.agency/"+point.clientCode+"/"+point.siteCode} target="_blank" rel="noopener noreferrer">{point.name} - {point.clientCode}</a></li> )}
						</ul>
					</div>
					<div>
						<div className="endpoints-header">
							<h2>Manage Data & Catalogs</h2>
							<h4>Edit Product Data</h4>
							<p style={{textAlign: 'center'}}><strong><a className="button" style={{display: 'inline-block'}} href="http://prodmin.mm-api.agency/?instance=sfn" target="_blank" rel="noopener noreferrer">Prodmin</a></strong></p>
							<div className="upload-wrapper">
								<h4>Upload Product Catalog</h4>
								<input type="file" name="sfnUpload" id="sfnUpload" />
								<InputRow label="Is This Catalog Client Specific? Leave empty if 'No'" type="select" options={sfnClients} property="clientCode" id="sfnClientCode" />
								<button className="button" onClick={() => this.upload("sfnUpload", "sfn")} >
									Upload Catalog <i className="fas fa-upload icon"></i>
								</button>
							</div>
						</div>

						<ul id="sfn-list" className="endpoint-list result-list">
							<h2>Velocity Data Endpoints</h2>
							<li><a href={allsfn} target="_blank" rel="noopener noreferrer">All Data</a></li>
							{sfnpoints.map(point => <li key={point.id}><a href={"https://sfn.mm-api.agency/"+point.clientCode+"/"+point.siteCode} target="_blank" rel="noopener noreferrer">{point.name} - {point.clientCode}</a></li> )}
						</ul>
					</div>
				</div>
			</div>
		)
	}
}

export default AllEndpoints;


// WEBPACK FOOTER //
// ./src/component_endpoints/All_Endpoints.js